var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asset-slot"},[_c('AssetUploadV2',{key:_vm.$vnode.key,ref:"asset",attrs:{"asset":_vm.item,"creative":_vm.creative,"parent":_vm.parent,"parent_slot":_vm.parent_slot}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }